/* tslint:disable */
/* eslint-disable */
/**
 * AS3.Portals
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Advisor } from './Advisor';
import {
    AdvisorFromJSON,
    AdvisorFromJSONTyped,
    AdvisorToJSON,
} from './Advisor';
import type { BusinessCountry } from './BusinessCountry';
import {
    BusinessCountryFromJSON,
    BusinessCountryFromJSONTyped,
    BusinessCountryToJSON,
} from './BusinessCountry';
import type { ContentSettings } from './ContentSettings';
import {
    ContentSettingsFromJSON,
    ContentSettingsFromJSONTyped,
    ContentSettingsToJSON,
} from './ContentSettings';
import type { Event } from './Event';
import {
    EventFromJSON,
    EventFromJSONTyped,
    EventToJSON,
} from './Event';
import type { HelpLink } from './HelpLink';
import {
    HelpLinkFromJSON,
    HelpLinkFromJSONTyped,
    HelpLinkToJSON,
} from './HelpLink';
import type { IPublishedContent } from './IPublishedContent';
import {
    IPublishedContentFromJSON,
    IPublishedContentFromJSONTyped,
    IPublishedContentToJSON,
} from './IPublishedContent';
import type { Parent } from './Parent';
import {
    ParentFromJSON,
    ParentFromJSONTyped,
    ParentToJSON,
} from './Parent';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { ProgrammeGroup } from './ProgrammeGroup';
import {
    ProgrammeGroupFromJSON,
    ProgrammeGroupFromJSONTyped,
    ProgrammeGroupToJSON,
} from './ProgrammeGroup';
import type { ProgrammeModule } from './ProgrammeModule';
import {
    ProgrammeModuleFromJSON,
    ProgrammeModuleFromJSONTyped,
    ProgrammeModuleToJSON,
} from './ProgrammeModule';
import type { TermsContent } from './TermsContent';
import {
    TermsContentFromJSON,
    TermsContentFromJSONTyped,
    TermsContentToJSON,
} from './TermsContent';
import type { TimeZoneInfo } from './TimeZoneInfo';
import {
    TimeZoneInfoFromJSON,
    TimeZoneInfoFromJSONTyped,
    TimeZoneInfoToJSON,
} from './TimeZoneInfo';

/**
 * 
 * @export
 * @interface Programme
 */
export interface Programme {
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    url?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    type?: string;
    /**
     * 
     * @type {Parent}
     * @memberof Programme
     */
    parent?: Parent;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    urlName?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    readonly updateDate?: string;
    /**
     * 
     * @type {Date}
     * @memberof Programme
     */
    publishedDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    helpText?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    helpVideo?: string;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    showHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    showExtendedHelp?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    pushContent?: boolean;
    /**
     * 
     * @type {Array<HelpLink>}
     * @memberof Programme
     */
    helpLinks?: Array<HelpLink>;
    /**
     * 
     * @type {any}
     * @memberof Programme
     */
    status?: any | null;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    programmeNo?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    advisorId?: string;
    /**
     * 
     * @type {Advisor}
     * @memberof Programme
     */
    advisor?: Advisor;
    /**
     * 
     * @type {Array<string>}
     * @memberof Programme
     */
    secondaryAdvisorIds?: Array<string>;
    /**
     * 
     * @type {Array<Advisor>}
     * @memberof Programme
     */
    secondaryAdvisors?: Array<Advisor>;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    fullEventListFetched?: boolean;
    /**
     * 
     * @type {Array<Event>}
     * @memberof Programme
     */
    events?: Array<Event>;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    ludusCode?: string;
    /**
     * 
     * @type {TermsContent}
     * @memberof Programme
     */
    terms?: TermsContent;
    /**
     * 
     * @type {Array<string>}
     * @memberof Programme
     */
    eventTemplates?: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof Programme
     */
    consentDate?: Date;
    /**
     * 
     * @type {ContentSettings}
     * @memberof Programme
     */
    contentSettings?: ContentSettings;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    name?: string;
    /**
     * 
     * @type {Product}
     * @memberof Programme
     */
    product?: Product;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    agreementProductId?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    agreementProductName?: string;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    businessArea?: string;
    /**
     * 
     * @type {BusinessCountry}
     * @memberof Programme
     */
    businessCountry?: BusinessCountry;
    /**
     * 
     * @type {string}
     * @memberof Programme
     */
    location?: string;
    /**
     * 
     * @type {Array<ProgrammeModule>}
     * @memberof Programme
     */
    modules?: Array<ProgrammeModule>;
    /**
     * 
     * @type {Array<ProgrammeGroup>}
     * @memberof Programme
     */
    groups?: Array<ProgrammeGroup>;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    readonly acceptedTerms?: boolean;
    /**
     * 
     * @type {TimeZoneInfo}
     * @memberof Programme
     */
    timeZone?: TimeZoneInfo;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    useNewFrontpage?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Programme
     */
    isOnCurrentDomain?: boolean;
    /**
     * 
     * @type {IPublishedContent}
     * @memberof Programme
     */
    frontPage?: IPublishedContent;
}

/**
 * Check if a given object implements the Programme interface.
 */
export function instanceOfProgramme(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ProgrammeFromJSON(json: any): Programme {
    return ProgrammeFromJSONTyped(json, false);
}

export function ProgrammeFromJSONTyped(json: any, ignoreDiscriminator: boolean): Programme {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'Id') ? undefined : json['Id'],
        'title': !exists(json, 'Title') ? undefined : json['Title'],
        'url': !exists(json, 'Url') ? undefined : json['Url'],
        'type': !exists(json, 'Type') ? undefined : json['Type'],
        'parent': !exists(json, 'Parent') ? undefined : ParentFromJSON(json['Parent']),
        'urlName': !exists(json, 'UrlName') ? undefined : json['UrlName'],
        'updateDate': !exists(json, 'UpdateDate') ? undefined : json['UpdateDate'],
        'publishedDate': !exists(json, 'PublishedDate') ? undefined : (new Date(json['PublishedDate'])),
        'helpText': !exists(json, 'HelpText') ? undefined : json['HelpText'],
        'helpVideo': !exists(json, 'HelpVideo') ? undefined : json['HelpVideo'],
        'showHelp': !exists(json, 'ShowHelp') ? undefined : json['ShowHelp'],
        'showExtendedHelp': !exists(json, 'ShowExtendedHelp') ? undefined : json['ShowExtendedHelp'],
        'pushContent': !exists(json, 'PushContent') ? undefined : json['PushContent'],
        'helpLinks': !exists(json, 'HelpLinks') ? undefined : ((json['HelpLinks'] as Array<any>).map(HelpLinkFromJSON)),
        'status': !exists(json, 'Status') ? undefined : json['Status'],
        'programmeNo': !exists(json, 'ProgrammeNo') ? undefined : json['ProgrammeNo'],
        'advisorId': !exists(json, 'AdvisorId') ? undefined : json['AdvisorId'],
        'advisor': !exists(json, 'Advisor') ? undefined : AdvisorFromJSON(json['Advisor']),
        'secondaryAdvisorIds': !exists(json, 'SecondaryAdvisorIds') ? undefined : json['SecondaryAdvisorIds'],
        'secondaryAdvisors': !exists(json, 'SecondaryAdvisors') ? undefined : ((json['SecondaryAdvisors'] as Array<any>).map(AdvisorFromJSON)),
        'fullEventListFetched': !exists(json, 'FullEventListFetched') ? undefined : json['FullEventListFetched'],
        'events': !exists(json, 'Events') ? undefined : ((json['Events'] as Array<any>).map(EventFromJSON)),
        'ludusCode': !exists(json, 'LudusCode') ? undefined : json['LudusCode'],
        'terms': !exists(json, 'Terms') ? undefined : TermsContentFromJSON(json['Terms']),
        'eventTemplates': !exists(json, 'EventTemplates') ? undefined : json['EventTemplates'],
        'consentDate': !exists(json, 'ConsentDate') ? undefined : (new Date(json['ConsentDate'])),
        'contentSettings': !exists(json, 'ContentSettings') ? undefined : ContentSettingsFromJSON(json['ContentSettings']),
        'name': !exists(json, 'Name') ? undefined : json['Name'],
        'product': !exists(json, 'Product') ? undefined : ProductFromJSON(json['Product']),
        'agreementProductId': !exists(json, 'AgreementProductId') ? undefined : json['AgreementProductId'],
        'agreementProductName': !exists(json, 'AgreementProductName') ? undefined : json['AgreementProductName'],
        'businessArea': !exists(json, 'BusinessArea') ? undefined : json['BusinessArea'],
        'businessCountry': !exists(json, 'BusinessCountry') ? undefined : BusinessCountryFromJSON(json['BusinessCountry']),
        'location': !exists(json, 'Location') ? undefined : json['Location'],
        'modules': !exists(json, 'Modules') ? undefined : ((json['Modules'] as Array<any>).map(ProgrammeModuleFromJSON)),
        'groups': !exists(json, 'Groups') ? undefined : ((json['Groups'] as Array<any>).map(ProgrammeGroupFromJSON)),
        'acceptedTerms': !exists(json, 'AcceptedTerms') ? undefined : json['AcceptedTerms'],
        'timeZone': !exists(json, 'TimeZone') ? undefined : TimeZoneInfoFromJSON(json['TimeZone']),
        'useNewFrontpage': !exists(json, 'UseNewFrontpage') ? undefined : json['UseNewFrontpage'],
        'isOnCurrentDomain': !exists(json, 'IsOnCurrentDomain') ? undefined : json['IsOnCurrentDomain'],
        'frontPage': !exists(json, 'FrontPage') ? undefined : IPublishedContentFromJSON(json['FrontPage']),
    };
}

export function ProgrammeToJSON(value?: Programme | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Id': value.id,
        'Title': value.title,
        'Url': value.url,
        'Type': value.type,
        'Parent': ParentToJSON(value.parent),
        'UrlName': value.urlName,
        'PublishedDate': value.publishedDate === undefined ? undefined : (value.publishedDate.toISOString()),
        'HelpText': value.helpText,
        'HelpVideo': value.helpVideo,
        'ShowHelp': value.showHelp,
        'ShowExtendedHelp': value.showExtendedHelp,
        'PushContent': value.pushContent,
        'HelpLinks': value.helpLinks === undefined ? undefined : ((value.helpLinks as Array<any>).map(HelpLinkToJSON)),
        'Status': value.status,
        'ProgrammeNo': value.programmeNo,
        'AdvisorId': value.advisorId,
        'Advisor': AdvisorToJSON(value.advisor),
        'SecondaryAdvisorIds': value.secondaryAdvisorIds,
        'SecondaryAdvisors': value.secondaryAdvisors === undefined ? undefined : ((value.secondaryAdvisors as Array<any>).map(AdvisorToJSON)),
        'FullEventListFetched': value.fullEventListFetched,
        'Events': value.events === undefined ? undefined : ((value.events as Array<any>).map(EventToJSON)),
        'LudusCode': value.ludusCode,
        'Terms': TermsContentToJSON(value.terms),
        'EventTemplates': value.eventTemplates,
        'ConsentDate': value.consentDate === undefined ? undefined : (value.consentDate.toISOString()),
        'ContentSettings': ContentSettingsToJSON(value.contentSettings),
        'Name': value.name,
        'Product': ProductToJSON(value.product),
        'AgreementProductId': value.agreementProductId,
        'AgreementProductName': value.agreementProductName,
        'BusinessArea': value.businessArea,
        'BusinessCountry': BusinessCountryToJSON(value.businessCountry),
        'Location': value.location,
        'Modules': value.modules === undefined ? undefined : ((value.modules as Array<any>).map(ProgrammeModuleToJSON)),
        'Groups': value.groups === undefined ? undefined : ((value.groups as Array<any>).map(ProgrammeGroupToJSON)),
        'TimeZone': TimeZoneInfoToJSON(value.timeZone),
        'UseNewFrontpage': value.useNewFrontpage,
        'IsOnCurrentDomain': value.isOnCurrentDomain,
        'FrontPage': IPublishedContentToJSON(value.frontPage),
    };
}

